import React from 'react';
import PropTypes from 'prop-types';
import FilterButton from '../../SharedComponents/FilterButton';
import { FILTER_VALUES, TRACKING_LABELS } from '../../constants';
import { trackEvent } from '../../../../../components/Analytics/TrackedClick';

const OpenRegistrationFilter = (props) => {
    const { filters, handleFilterUpdate } = props;
    const { OPEN_REGISTRATION } = FILTER_VALUES;

    const handleClick = () => {
        handleFilterUpdate({
            eventState: OPEN_REGISTRATION,
            startDate: null,
            endDate: null,
            dateRange: null,
        }, 'submit');

        const { OPEN_REGISTRATION: OPEN_REGISTRATION_LABEL, CLIENT, EVENT_NAME } = TRACKING_LABELS;
        trackEvent(EVENT_NAME, {
            filter_name: OPEN_REGISTRATION_LABEL,
            client: CLIENT,
        });
    };

    return (
        <FilterButton
            isActive={filters.eventState === OPEN_REGISTRATION}
            onClick={handleClick}
        >
            Open Registration
        </FilterButton>
    );
};

OpenRegistrationFilter.propTypes = {
    filters: PropTypes.instanceOf(Object).isRequired,
    handleFilterUpdate: PropTypes.func.isRequired,
};

export default OpenRegistrationFilter;
